import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useSystemInformationStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: {
        marginTop: `5px`
      }
    }),
    []
  );
}
